import { ENABLE_MENU, SHOW_MENU } from "./constants";

const initialState = {
	show: false,
	enable: true
};

const reducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case SHOW_MENU:
		case ENABLE_MENU:
			return { ...state, ...payload };
		default:
			return state;
	}
};

export default reducer;
